module.exports = __webpack_public_path__ + "media/npc_dota_hero_mars.79dd122f.webm";